import React from "react";
import { Function0, Function1 } from "lodash";
import fp from "lodash/fp";
import { Modal, Row, Col, ModalProps } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Field, reduxForm, isDirty, InjectedFormProps } from "redux-form";

import {
	CloseButton,
	Button,
	DatePickerFieldWrapper,
	DatePickerCommon,
	DatePickerWithLabelWrapper,
} from "components";

import styles from "./paymentsModal.module.scss";

const FORM_NAME = "updatePayoutDateForm";

type UpdateDateModalProps = {
	show: boolean;
	onHide: Function0<void>;
	dialogAs: ModalProps["dialogAs"];
	backdrop: any;
	updateDate: Function1<
		{ values: { [key: string]: any } },
		Promise<void> | void
	>;
};

type UpdateDateModalType = React.FC<
	InjectedFormProps<UpdateDateModalProps> & UpdateDateModalProps
>;
const UpdateDateModal: UpdateDateModalType = ({
	show,
	onHide,
	updateDate,
	handleSubmit,
}) => {
	const isDirtyForm = useSelector(isDirty(FORM_NAME));

	const handleUpdateDate = async values => {
		try {
			await updateDate(values);
		} finally {
			onHide();
		}
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			animation={false}
			centered
			scrollable
			id="updateDateModal"
		>
			<Modal.Header className="pb-2">
				<Modal.Title className="text-center">
					Update Value Date
				</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body style={{ maxHeight: "75vh" }}>
				<form onSubmit={handleSubmit(handleUpdateDate)}>
					<Row
						className="d-flex justify-content-center"
						style={{ height: "26vh" }}
					>
						<Col
							md={{ span: 4 }}
							className="d-flex align-items-baseline"
						>
							<Field
								component={DatePickerWithLabelWrapper}
								name="updateValueDate"
								labelClass={styles.dateLabel}
								label="Value Date"
								renderDatePicker={(input, meta) => (
									<DatePickerFieldWrapper
										input={input}
										meta={meta}
										datePickerComponent={DatePickerCommon}
										placeholderText="MM/DD/YYYY"
									/>
								)}
							/>
						</Col>
					</Row>
					<Row>
						<Col className="d-flex justify-content-center mb-3">
							<Button
								disabled={!isDirtyForm}
								value="Update"
								type="submit"
							/>
						</Col>
					</Row>
				</form>
			</Modal.Body>
		</Modal>
	);
};

const component = fp.flow(
	reduxForm({
		destroyOnUnmount: true,
		form: FORM_NAME,
	}),
)(UpdateDateModal);
export { component as UpdateDateModal };
